import { ChangeEvent, FC, useState } from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import clsx from 'clsx'

import { FieldCode } from '../../../fullscreen-popups/registration/registration-code/data'

import styles from './controller-code-input.module.scss'

interface IControllerCodeInput {
  onClick?: () => void
  control?: Control<any, any>
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  inputValue: string
  inputRef?: any
  errors: FieldErrors
}

const ControllerCodeInput: FC<IControllerCodeInput> = ({
  onClick,
  control,
  onChange,
  inputValue,
  inputRef,
  errors,
}) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <>
      <div className={styles.hidenInput} onClick={onClick}>
        <Controller
          control={control}
          name={FieldCode}
          render={({ field: { onBlur } }) => {
            return (
              <input
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  onChange(e)
                }}
                onBlur={() => {
                  onBlur()
                  setIsFocused(false)
                }}
                onFocus={() => {
                  setIsFocused(true)
                }}
                type="number"
                value={inputValue}
                ref={inputRef}
              ></input>
            )
          }}
        />
      </div>
      <div className={styles.codeZone}>
        {Array.from(Array(4).keys()).map((index) => {
          return (
            <div
              key={index}
              className={clsx(styles.valueZone, {
                [styles.zoneActive]: isFocused && inputValue.length === index,
                [styles.zoneError]: errors[FieldCode]?.message,
              })}
            >
              {inputValue[index]}
            </div>
          )
        })}
      </div>
      {errors[FieldCode] && <div className={styles.error}>{errors[FieldCode]?.message}</div>}
    </>
  )
}

export default ControllerCodeInput
